import React, { forwardRef, useImperativeHandle, useRef, useState, useCallback } from 'react';
import { SessionV2 } from '../../../api/sessionsV2Api';
import BonusPaymentBottomSheet from './BonusPaymentBottomSheet';

export interface BonusSheetHostHandle {
  open: (sessions: SessionV2[]) => void;
}

interface BonusSheetHostProps {
  siteId: number;
  onClose: () => void;
  onSuccess: () => void;
}

const BonusSheetHost = forwardRef<BonusSheetHostHandle, BonusSheetHostProps>((props, ref) => {
  const { siteId, onClose: parentOnClose, onSuccess: parentOnSuccess } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [sessions, setSessions] = useState<SessionV2[]>([]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setSessions([]);
    parentOnClose();
  }, [parentOnClose]);

  const handleSuccess = useCallback(() => {
    setIsOpen(false);
    setSessions([]);
    parentOnSuccess();
  }, [parentOnSuccess]);

  useImperativeHandle(ref, () => ({
    open: (sessionsToBonus: SessionV2[]) => {
      setSessions(sessionsToBonus);
      setIsOpen(true);
    }
  }), []);

  return (
    <BonusPaymentBottomSheet
      isOpen={isOpen}
      sessions={sessions}
      siteId={siteId}
      onClose={handleClose}
      onSuccess={handleSuccess}
    />
  );
});

BonusSheetHost.displayName = 'BonusSheetHost';

export default BonusSheetHost;
